import { jsxs as e, jsx as C } from "react/jsx-runtime";
function L(l) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "124",
      height: "31",
      viewBox: "0 0 124 31",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...l,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M46.2113 6.75H39.3723C38.9043 6.75 38.5063 7.09 38.4333 7.552L35.6673 25.089C35.6123 25.435 35.8803 25.747 36.2313 25.747H39.4963C39.9643 25.747 40.3623 25.407 40.4353 24.944L41.1813 20.214C41.2533 19.751 41.6523 19.411 42.1193 19.411H44.2843C48.7893 19.411 51.3893 17.231 52.0683 12.911C52.3743 11.021 52.0813 9.536 51.1963 8.496C50.2243 7.354 48.5003 6.75 46.2113 6.75ZM47.0002 13.1569C46.6263 15.6109 44.7513 15.6109 42.9383 15.6109H41.9062L42.6302 11.0279C42.6733 10.7509 42.9132 10.5469 43.1933 10.5469H43.6663C44.9012 10.5469 46.0662 10.5469 46.6683 11.2509C47.0273 11.6709 47.1373 12.2949 47.0002 13.1569Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.654 13.0736H63.379C63.1 13.0736 62.859 13.2776 62.816 13.5546L62.671 14.4706L62.442 14.1386C61.733 13.1096 60.152 12.7656 58.574 12.7656C54.955 12.7656 51.864 15.5066 51.262 19.3516C50.949 21.2696 51.394 23.1036 52.482 24.3826C53.48 25.5586 54.908 26.0486 56.607 26.0486C59.523 26.0486 61.14 24.1736 61.14 24.1736L60.994 25.0836C60.939 25.4316 61.207 25.7436 61.556 25.7436H64.506C64.975 25.7436 65.371 25.4036 65.445 24.9406L67.215 13.7316C67.271 13.3866 67.004 13.0736 66.654 13.0736ZM62.09 19.4473C61.774 21.3183 60.289 22.5743 58.395 22.5743C57.444 22.5743 56.684 22.2693 56.196 21.6913C55.712 21.1173 55.528 20.3003 55.682 19.3903C55.977 17.5353 57.487 16.2383 59.352 16.2383C60.282 16.2383 61.038 16.5473 61.536 17.1303C62.035 17.7193 62.233 18.5413 62.09 19.4473Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M84.0946 13.0742H80.8036C80.4896 13.0742 80.1946 13.2302 80.0166 13.4912L75.4776 20.1772L73.5536 13.7522C73.4326 13.3502 73.0616 13.0742 72.6416 13.0742H69.4076C69.0146 13.0742 68.7416 13.4582 68.8666 13.8282L72.4916 24.4662L69.0836 29.2772C68.8156 29.6562 69.0856 30.1772 69.5486 30.1772H72.8356C73.1476 30.1772 73.4396 30.0252 73.6166 29.7692L84.5626 13.9692C84.8246 13.5912 84.5556 13.0742 84.0946 13.0742L84.0946 13.0742Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M94.9926 6.75H88.1526C87.6856 6.75 87.2876 7.09 87.2146 7.552L84.4486 25.089C84.3936 25.435 84.6616 25.747 85.0106 25.747H88.5206C88.8466 25.747 89.1256 25.509 89.1766 25.185L89.9616 20.214C90.0336 19.751 90.4326 19.411 90.8996 19.411H93.0636C97.5696 19.411 100.169 17.231 100.849 12.911C101.156 11.021 100.861 9.536 99.9756 8.496C99.0046 7.354 97.2816 6.75 94.9926 6.75H94.9926ZM95.7805 13.1569C95.4075 15.6109 93.5325 15.6109 91.7185 15.6109H90.6875L91.4125 11.0279C91.4555 10.7509 91.6935 10.5469 91.9745 10.5469H92.4475C93.6815 10.5469 94.8475 10.5469 95.4495 11.2509C95.8085 11.6709 95.9175 12.2949 95.7805 13.1569Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M115.435 13.0736H112.162C111.881 13.0736 111.642 13.2776 111.6 13.5546L111.455 14.4706L111.225 14.1386C110.516 13.1096 108.936 12.7656 107.358 12.7656C103.739 12.7656 100.649 15.5066 100.047 19.3516C99.7349 21.2696 100.178 23.1036 101.266 24.3826C102.266 25.5586 103.692 26.0486 105.391 26.0486C108.307 26.0486 109.924 24.1736 109.924 24.1736L109.778 25.0836C109.723 25.4316 109.991 25.7436 110.342 25.7436H113.291C113.758 25.7436 114.156 25.4036 114.229 24.9406L116 13.7316C116.054 13.3866 115.786 13.0736 115.435 13.0736H115.435ZM110.87 19.4473C110.556 21.3183 109.069 22.5743 107.175 22.5743C106.226 22.5743 105.464 22.2693 104.976 21.6913C104.492 21.1173 104.31 20.3003 104.462 19.3903C104.759 17.5353 106.267 16.2383 108.132 16.2383C109.062 16.2383 109.818 16.5473 110.316 17.1303C110.817 17.7193 111.015 18.5413 110.87 19.4473Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M119.295 7.232L116.488 25.09C116.433 25.436 116.701 25.748 117.05 25.748H119.872C120.341 25.748 120.739 25.408 120.811 24.945L123.579 7.409C123.634 7.063 123.366 6.75 123.017 6.75H119.857C119.578 6.751 119.338 6.955 119.295 7.232Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.2675 29.1534L7.7905 25.8314L6.6255 25.8044H1.0625L4.9285 1.29144C4.9405 1.21744 4.9795 1.14844 5.0365 1.09944C5.0935 1.05044 5.1665 1.02344 5.2425 1.02344H14.6225C17.7365 1.02344 19.8855 1.67144 21.0075 2.95044C21.5335 3.55044 21.8685 4.17744 22.0305 4.86744C22.2005 5.59144 22.2035 6.45644 22.0375 7.51144L22.0255 7.58844V8.26444L22.5515 8.56244C22.9945 8.79744 23.3465 9.06644 23.6165 9.37444C24.0665 9.88744 24.3575 10.5394 24.4805 11.3124C24.6075 12.1074 24.5655 13.0534 24.3575 14.1244C24.1175 15.3564 23.7295 16.4294 23.2055 17.3074C22.7235 18.1164 22.1095 18.7874 21.3805 19.3074C20.6845 19.8014 19.8575 20.1764 18.9225 20.4164C18.0165 20.6524 16.9835 20.7714 15.8505 20.7714H15.1205C14.5985 20.7714 14.0915 20.9594 13.6935 21.2964C13.2945 21.6404 13.0305 22.1104 12.9495 22.6244L12.8945 22.9234L11.9705 28.7784L11.9285 28.9934C11.9175 29.0614 11.8985 29.0954 11.8705 29.1184C11.8455 29.1394 11.8095 29.1534 11.7745 29.1534H7.2675Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M12.0772 16.763C17.4822 16.763 21.7142 14.569 22.9512 8.21797L23.0472 7.66797C23.5722 7.94597 24.0212 8.28697 24.3832 8.69797C25.5792 10.061 25.8132 11.999 25.3612 14.32C24.2792 19.876 20.5772 21.796 15.8482 21.796H15.1182C14.5402 21.796 14.0482 22.216 13.9582 22.788L13.8992 23.108L12.9802 28.94L12.9322 29.188C12.8412 29.758 12.3502 30.178 11.7722 30.178H6.89117C6.45917 30.178 6.12917 29.792 6.19617 29.364L6.59517 26.831L8.00417 17.895C8.10717 17.243 8.66417 16.763 9.32517 16.763H12.0772Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7529 7.15103C21.5639 7.09603 21.3689 7.04603 21.1689 7.00103C20.9679 6.95703 20.7619 6.91803 20.5499 6.88403C19.8079 6.76403 18.9949 6.70703 18.1239 6.70703H10.7719C10.5909 6.70703 10.4189 6.74803 10.2649 6.82203C9.92591 6.98503 9.67391 7.30603 9.61291 7.69903L8.04891 17.605L8.00391 17.894C8.10691 17.242 8.66391 16.762 9.32491 16.762H12.0769C17.4819 16.762 21.7139 14.567 22.9509 8.21703C22.9879 8.02903 23.0189 7.84603 23.0469 7.66703C22.7339 7.50103 22.3949 7.35903 22.0299 7.23803C21.9399 7.20803 21.8469 7.17903 21.7529 7.15103Z",
            fill: "#222D65"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.61399 7.699C9.67499 7.306 9.92699 6.985 10.266 6.823C10.421 6.749 10.592 6.708 10.773 6.708H18.125C18.996 6.708 19.809 6.765 20.551 6.885C20.763 6.919 20.969 6.958 21.17 7.002C21.37 7.047 21.565 7.097 21.754 7.152C21.848 7.18 21.941 7.209 22.032 7.238C22.397 7.359 22.736 7.502 23.049 7.667C23.417 5.32 23.046 3.722 21.777 2.275C20.378 0.682 17.853 0 14.622 0H5.24199C4.58199 0 4.01899 0.48 3.91699 1.133L0.00998882 25.898C-0.0670112 26.388 0.310989 26.83 0.804989 26.83H6.59599L8.04999 17.605L9.61399 7.699Z",
            fill: "#253B80"
          }
        )
      ]
    }
  );
}
export {
  L as PaypalLogoIcon
};
